import Link from './Link'
import Media from './Media'
import { Profile } from './Profile'

type WallPin = TextWallPin | LinkWallPin | MediaWallPin

enum WALL_PIN_TYPE {
	TEXT = 'text',
	LINK = 'link',
	MEDIA = 'media',
}

type TextWallPin = BaseWallPin & {
	type: WALL_PIN_TYPE.TEXT
	data: TextWallPinData
}

type LinkWallPin = BaseWallPin & {
	type: WALL_PIN_TYPE.LINK
	data: Link
}

type MediaWallPin = BaseWallPin & {
	type: WALL_PIN_TYPE.MEDIA
	data: Media
}

type TextWallPinData = {
	time: number
	version: string
	blocks: {
		id: string
		type: 'header' | 'paragraph' | 'list' | 'quote' | 'delimiter'
		data: any
	}[]
}

type BaseWallPin = {
	id?: string
	type: WALL_PIN_TYPE
	owner?: Profile
	created?: Date
	data: unknown
}

export {
	WallPin,
	WALL_PIN_TYPE,
	TextWallPin,
	TextWallPinData,
	LinkWallPin,
	MediaWallPin,
}
